import React from 'react';

const Footer = ({ releaseVersion }) => {
   const currentYear = new Date().getFullYear();

        return (
                <div className='footer'>
                    <div className='footer__copyright fill--2'>
                        <div className='footer__copyright-content'>
                            <span>
                                © {currentYear} GE HealthCare. GE is a trademark of General Electric Company. Used under trademark license.
                            </span>
                            <span className="footer__version">
                              {releaseVersion || ""}
                              
                            </span>
                        </div>
                    </div>
                </div>
            );
        }


export default Footer;